var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseIcon',{staticClass:"category-icon",attrs:{"stripe-url":_vm.stripeUrl,"icon-name":_vm.iconName}})
}
var staticRenderFns = []

export { render, staticRenderFns }